export default __webpack_public_path__ + "static/media/bed_200x200.7dfc4d08.jpg";